export default __webpack_public_path__ + "static/media/facebook.0bf59b2a.svg";